<div class="lang-dialog">
	<div class="lang-header">
		<div class="lang-header-icon">
			<mat-icon>translate</mat-icon>
		</div>
		<div class="lang-header-text">
			<h2>{{ "languageSelector.title" | translate }}</h2>
			<p>{{ "languageSelector.subtitle" | translate }}</p>
		</div>
		<button class="lang-close" (click)="cancel()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="lang-body">
		<div class="lang-current">
			<mat-icon class="lang-current-icon">check_circle</mat-icon>
			<span>{{ "languageSelector.currentLabel" | translate }}</span>
		</div>

		<div class="lang-options">
			<button
				*ngFor="let lang of languages"
				class="lang-card"
				[class.active]="lang.code === selectedCode"
				(click)="selectLanguage(lang.code)"
			>
				<img class="lang-flag" [src]="lang.flag" [alt]="lang.nativeLabel + ' flag'" />
				<div class="lang-card-text">
					<span class="lang-name">{{ lang.label }}</span>
					<span class="lang-native">{{ lang.nativeLabel }}</span>
				</div>
				<div class="lang-check" *ngIf="lang.code === selectedCode">
					<mat-icon>check</mat-icon>
				</div>
			</button>
		</div>
	</div>

	<div class="lang-footer">
		<button class="lang-btn-cancel" (click)="cancel()">
			{{ "languageSelector.cancel" | translate }}
		</button>
		<button
			class="lang-btn-confirm"
			(click)="confirm()"
			[disabled]="selectedCode === data.currentLang"
		>
			{{ "languageSelector.confirm" | translate }}
		</button>
	</div>
</div>
